import { apiWithAuth, apiWithoutAuth } from "./utils";

export class User {
  constructor(private readonly mountPath: string) {}

  // Create a new user (registration or admin creation)
  async createUser(userData: { [key: string]: any }, isAdmin = false) {
    if (isAdmin) {
      return await apiWithAuth.post(`${this.mountPath}`, userData);
    }
    return await apiWithoutAuth.post(`${this.mountPath}`, userData);
  }
  // Fetch user details by user ID
  async getUserById(userId: string) {
    return await apiWithoutAuth.get(`${this.mountPath}/${userId}`);
  }

  // Update user details
  async updateUser(userId: string, updatedData: { [key: string]: any }) {
    return await apiWithAuth.put(`${this.mountPath}/${userId}`, updatedData);
  }

  // Delete user by ID
  async deleteUser(userId: string) {
    return await apiWithAuth.delete(`${this.mountPath}/${userId}`);
  }

  // Fetch all users with optional query parameters (e.g., for pagination)
  async getAllUsers(queryParams: { [key: string]: any } = {}) {
    const queryString = new URLSearchParams(queryParams).toString();
    return await apiWithAuth.get(`${this.mountPath}?${queryString}`);
  }
}
